import React from "react";

import { SearchInput } from "../../../../components/Input";
import { plural } from "../../utils/format";
import { ORDER_OPTIONS, STATUS_OPTIONS } from "../constants";
import {
  Toolbar,
  ToolbarCount,
  ToolbarField,
  ToolbarSearch,
  ToolbarSelect,
} from "../../styles";
import { WorkOrder, WorkQueueToolbarProps, WorkStatusFilter } from "../types";

export const WorkQueueToolbar: React.FC<WorkQueueToolbarProps> = ({
  view,
  itemCount,
  onFiltersChange,
  onOrderChange,
}) => {
  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) =>
    onFiltersChange({ query: event.target.value });
  const handleClearSearch = () => onFiltersChange({ query: "" });
  const handleStatus = (event: React.ChangeEvent<HTMLSelectElement>) =>
    onFiltersChange({ status: event.target.value as WorkStatusFilter });
  const handleOrder = (event: React.ChangeEvent<HTMLSelectElement>) =>
    onOrderChange(event.target.value as WorkOrder);

  return (
    <Toolbar>
      <ToolbarSearch>
        <SearchInput
          aria-label="Search work queue"
          placeholder="Search symbol, name or exchange"
          value={view.query}
          onChange={handleSearch}
          onClear={handleClearSearch}
        />
      </ToolbarSearch>
      <ToolbarField>
        Status
        <ToolbarSelect value={view.status} onChange={handleStatus}>
          {STATUS_OPTIONS.map(({ value, label }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </ToolbarSelect>
      </ToolbarField>
      <ToolbarField>
        Order
        <ToolbarSelect value={view.order} onChange={handleOrder}>
          {ORDER_OPTIONS.map(({ value, label }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </ToolbarSelect>
      </ToolbarField>
      <ToolbarCount>{plural(itemCount, "item")}</ToolbarCount>
    </Toolbar>
  );
};
